<script>
import VButton from "../Button.vue";
import Form from "vform";

export default {
    name: 'Challenge2Fa',
    components: {VButton},
    props: [
        'url',
        'accessToModel',
        'accessToModelId',
        'accessToDataType',
        'accessToFieldName',
    ],
    data: () => ({
        form2FA: new Form(),
        code: null,
    }),
    methods: {
        async check2FA() {
            let self = this;
            let data = {
                code: self.code,

                url: this.url,
                accessToModel: this.accessToModel,
                accessToModelId: this.accessToModelId,
                accessToDataType: this.accessToDataType,
                accessToFieldName: this.accessToFieldName,
            };
            this.form2FA = new Form(data);
            this.form2FA.post('/api/challenge2FA')
                .then(res => {
                    self.code = null;
                    self.$emit('success', data)
                })
        }
    }
}
</script>

<template>
    <form @submit.prevent="check2FA" @keydown="form2FA.onKeydown($event)">
        <div class="form-group">
            <label>Код из приложения Google Authenticator</label>
            <input ref="code" v-model="code" :class="{ 'is-invalid': form2FA.errors.has('code') }" class="form-control form-control-lg" autocomplete="off" name="code">
            <has-error :form="form2FA" field="code"/>
        </div>
        <div class="text-center mt-3">
            <v-button :loading="form2FA.busy" :large="true" :type="'primary'">Отправить</v-button>
        </div>
    </form>
</template>

<style scoped>

</style>